import { render } from "./TopbarNav.vue?vue&type=template&id=4801181e&scoped=true"
import script from "./TopbarNav.vue?vue&type=script&lang=js"
export * from "./TopbarNav.vue?vue&type=script&lang=js"

import "./TopbarNav.vue?vue&type=style&index=0&id=4801181e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4801181e"]])

export default __exports__